import { Component, OnInit } from '@angular/core';
import { MaintenanceMessageService } from './maintenance-message.service';
import * as moment from 'moment';

@Component({
    selector: 'maintenance-message',
    template: require('./maintenance-message.component.html'),
    styles: [require('./maintenance-message.component.scss')]
})

export class MaintenanceMessageComponent implements OnInit {
    hide = false;
    scheduleDetails: any;
    startTime: any = '';
    endTime: any = '';
    isPriorDate: any = false;
    priorInterval: any;
    showMessage: boolean = false;
    tzName: string;
    constructor(private maintenanceMessageService: MaintenanceMessageService) { }

    ngOnInit() { 
        this.maintenanceMessageService.getSchedulingDetails()
        .subscribe(data => {
            if (data && data.length) {
                this.scheduleDetails = data[0];

                this.startTime = moment(data[0].START_TIME + ' +0000', 'YYYY-MM-DD HH:mm:ss Z').format('YYYY-MM-DD HH:mm:ss');
                // this.startTime = moment('2023-09-09 21:05:25 +0000', 'YYYY-MM-DD HH:mm:ss Z').format('YYYY-MM-DD HH:mm:ss');

                this.endTime = moment(data[0].END_TIME + ' +0000', 'YYYY-MM-DD HH:mm:ss Z').format('YYYY-MM-DD HH:mm:ss');
                // this.endTime = moment('2023-09-09 21:06:25 +0000', 'YYYY-MM-DD HH:mm:ss Z').format('YYYY-MM-DD HH:mm:ss');

                this.showMessage = data[0].ENABLED;

                let d = new Date(this.endTime);
                this.tzName = d.toLocaleString('en', {timeZoneName:'short'}).split(' ').pop();

                this.isPriorDate = moment().isSameOrBefore(this.startTime);

                this.priorInterval = setInterval(() => {
                    this.checkPriorDate();
                }, 10000);
            }
        },
        () => {});
    }

    checkPriorDate() {
        this.isPriorDate = moment().isSameOrBefore(this.startTime);
        if (!this.isPriorDate) {
            clearInterval(this.priorInterval);
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/maintenance-message/maintenance-message.component.ts